'use client';

import { Tab } from '@mui/material';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { type FC, type ReactElement, type ReactNode, useMemo } from 'react';
type Props = {
  tabMaxWidth: string;
  icon: ReactElement;
  href: string;
  value?: string;
  disabled?: boolean;
  matchExact?: boolean;
  label: ReactNode;
  order?: number;
};
export const TabItem: FC<Props> = props => {
  const {
    tabMaxWidth,
    icon,
    href,
    value,
    label,
    order = 1,
    disabled = false,
    matchExact = false
  } = props;
  const pathname = usePathname();
  const selected = useMemo(() => matchExact ? pathname === href : pathname.startsWith(href), [pathname, href, matchExact]);
  return <Tab LinkComponent={Link} href={href} value={value || href} icon={icon} iconPosition="top" label={label} disabled={disabled} sx={{
    flex: '1 1 0%',
    padding: '8px 2px',
    minWidth: 'unset',
    minHeight: '4rem',
    width: tabMaxWidth,
    color: selected ? 'primary.main' : 'inherit',
    opacity: 1,
    bgcolor: selected ? 'background.primary' : 'background.paper',
    order: order
  }} data-sentry-element="Tab" data-sentry-component="TabItem" data-sentry-source-file="tab-item.tsx" />;
};